"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_COLORS = void 0;
exports.ICON_COLORS = {
    fill: '#26324E',
};



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/icon.ts
// module id = 26
// module chunks = 0 1 2